import React, { useContext, useEffect, useState } from "react";
import ICatalog_Item from "../../../models/ICatalog_Item";
import OwLabel from "../../shared/OwLabel/OwLabel";
import OwButton from "../../shared/OwButton/OwButton";
import { OwFnInput } from "../../shared/OwFnInput/OwFnInput";
import OwTitle from "../../shared/OwTitle/OwTitle";
import SupplierContext from "../../../contexts/SupplierContext";
import { CatalogItemPriceBandBuilder } from "../../catalogs/CatalogOverview/CreateCatalogItemSidebar/CatalogItemPriceBandBuilder/CatalogItemPriceBandBuilder";
import IVendor_Source from "../../../models/IVendor_Source";
import IPrice_Group from "../../../models/IPrice_Group";
import IPrice_Band_Compiled from "../../../models/IPrice_Band_Compiled";
import UserContext from "../../../contexts/UserContext";
import { SocketContext } from "../../../contexts/SocketContext";
import IUiSocketSetup from "../../../models/IUiSocketSetup";
import EndpointsEnum from "../../../models/EndpointsEnum";
import IOnProcessVendorSourceCatalogItemDTO from "../../../models/DTO/IOnProcessVendorSourceCatalogItemDTO";
import IProcessVendorSourceCatalogItemDTO from "../../../models/DTO/IProcessVendorSourceCatalogItemDTO";

type Props = {
    catalogItem: ICatalog_Item;
    closeFn: (refresh?: boolean) => void;
    vendorSource: IVendor_Source;
};

export const VendorSourceCatalogItemSidebar = (props: Props) => {
    const supplierModel = useContext(SupplierContext);
    const userModel = useContext(UserContext);
    const socket = useContext(SocketContext)!;

    const onProcessVendorSourceCatalogItem = (data: IOnProcessVendorSourceCatalogItemDTO) => {
        props.closeFn();
    };

    const sockets: IUiSocketSetup[] = [
        { endpoint: EndpointsEnum.PurchaseOrderOnProcessVendorSourceCatalogItem, fn: onProcessVendorSourceCatalogItem },
        // { endpoint: EndpointsEnum.CatalogItemOnUpdateCatalogItem, fn: onUpdateCatalogItem },
    ];

    const save = () => {
        const payload: IProcessVendorSourceCatalogItemDTO = {
            userGuid: userModel.guid,
            userToken: userModel.token,
            supplierGuid: supplierModel.guid,
            vendorSourceGuid: props.vendorSource.guid,
            catalogItems: [
                {
                    ...props.catalogItem,
                    costPrice,
                    manuf_part_no: mpn,
                    priceBands: {
                        [`${props.vendorSource.name}_cost`]: priceBands,
                    },
                },
            ],
        };

        socket.emit(EndpointsEnum.PurchaseOrderProcessVendorSourceCatalogItem, payload);
    };

    useEffect(() => {
        for (const _socket of sockets) {
            socket.on(_socket.endpoint, _socket.fn);
        }

        return () => {
            for (const _socket of sockets) {
                socket.off(_socket.endpoint, _socket.fn);
            }
        };
    });

    const [mpn, setMpn] = useState(props.catalogItem.Catalog_Item_Vendor_Source_Map?.manuf_part_no || "");
    const [costPrice, setCostPrice] = useState(props.catalogItem.Catalog_Item_Vendor_Source_Map?.cost_price || 0);
    const [priceBands, setPriceBands] = useState<IPrice_Band_Compiled[]>(
        props.catalogItem.Price_Bands ? props.catalogItem.Price_Bands[`${props.vendorSource.name}_cost`] || [] : []
    );

    const handleChange = (e: any) => {
        const name = e.target.name;
        const value = e.target.value;

        switch (name) {
            case "mpn":
                setMpn(value);
                break;

            case "cost_price":
                setCostPrice(value);
                break;
        }
    };

    const handleBandUpdate = (band: IPrice_Band_Compiled[], priceGroup?: IPrice_Group, vendorSource?: IVendor_Source) => {
        setPriceBands(band);
    };

    return (
        <div className={"VendorSourceCatalogItemSidebar p-2"}>
            <div className={"d-flex justify-content-between align-items-center"}>
                <OwTitle title={"update_catalog_item"} tag={"h3"} />
                <div>
                    <OwButton
                        className={"btn-danger"}
                        centerIconClass={"fas fa-times"}
                        fn={() => {
                            props.closeFn();
                        }}
                    />
                </div>
            </div>
            <div className={"mt-4"}>
                <OwLabel title={"catalog"} isBold={true} />
                <div>{props.catalogItem.Catalog?.name}</div>
            </div>
            <div className={"mt-4"}>
                <OwLabel title={"name"} isBold={true} />
                <div>{props.catalogItem.name}</div>
            </div>
            <div className={"mt-4"}>
                <OwLabel title={"sku"} isBold={true} />
                <div>{props.catalogItem.sku}</div>
            </div>
            <div className={"mt-4"}>
                <OwLabel title={"manuf_part_no"} isBold={true} />
                <div>
                    <OwFnInput fn={handleChange} name={"mpn"} value={mpn} />
                </div>
            </div>
            <div className={"mt-4"}>
                <OwLabel title={"cost_price"} isBold={true} />
                {props.catalogItem.has_price_bands ? (
                    <div>
                        <CatalogItemPriceBandBuilder
                            catalogId={props.catalogItem.catalog_id}
                            band={priceBands}
                            handleBandUpdate={handleBandUpdate}
                            vendorSource={props.vendorSource}
                        />
                    </div>
                ) : (
                    <OwFnInput fn={handleChange} name={"cost_price"} value={costPrice} />
                )}
            </div>

            <div className={"mt-4"}>
                <OwButton className={"btn-primary me-2"} title={"save"} fn={save} />
                <OwButton
                    className={"btn-danger"}
                    title={"close"}
                    fn={() => {
                        props.closeFn();
                    }}
                />
            </div>
        </div>
    );
};
